<template>
  <div>
    <a-card style="margin: 20px">
      <template #title>
        <div class="top-title">
          <div class="left"><span>代销协议管理</span></div>
          <div class="right">
            <DepartmentChoose :department-code.sync="form.departmentCode"
                              @change="departmentIdchange"></DepartmentChoose>
          </div>
        </div>
      </template>

      <!-- 查询 -->
      <div class="formbox">
        <div class="inputbox">
          <div class="lefttitle">合同号</div>
          <a-input v-model.trim="form.contractNo" placeholder="请输入合同号" allowClear style="width: 200px" />
        </div>
        <div class="inputbox">
          <div class="lefttitle">商户号</div>
          <MchChooseDialog v-model="form.mchName" @chooseDone="onMchChosenForQuery"></MchChooseDialog>
        </div>
        <div class="inputbox">
          <div class="lefttitle">合同状态</div>
          <a-select v-model="form.status" placeholder="请选择状态" allowClear style="width: 200px">
            <a-select-option v-for="o in contractStatusOptions" :key="o.value" :value="o.value">
              <a-tag :color="o.color">{{ o.label }}</a-tag>
            </a-select-option>
          </a-select>
        </div>
        <div class="inputbox">
          <div class="lefttitle">创建日期</div>
          <a-range-picker valueFormat="YYYY-MM-DD" v-model="dateRange"
                          @change="onDateChange" style="width: 240px"
                          placeholder="['开始日期','结束日期']" />
        </div>
        <a-button @click="search" type="primary">查询</a-button>
        <a-button @click="reset" class="reset">重置</a-button>
      </div>

      <!-- 工具栏 -->
      <div class="Toleadinto">
        <a-button-group>
          <a-button @click="goAdd" type="primary" icon="plus"
                    v-if="$authority('consignContractAdd')">新增合同</a-button>
          <a-button @click="goDetail" type="normal" icon="eye"
                    :disabled="selectedRows.length !== 1"
                    v-if="$authority('consignContractView')">查看详情</a-button>
          <a-button @click="goEdit" type="primary" icon="edit"
                    :disabled="!canEdit()"
                    v-if="$authority('consignContractAdd')">编辑</a-button>
          <a-button @click="openApprove" type="primary" icon="audit"
                    :disabled="!canApprove()"
                    v-if="$authority('consignContractApprove')">审批</a-button>
          <a-button @click="doSync" type="normal" icon="redo"
                    :disabled="!canSync()"
                    v-if="$authority('consignContractSync')">同步银行</a-button>
          <a-button @click="openInvalid" type="danger" icon="delete"
                    :disabled="!canInvalid()"
                    v-if="$authority('consignContractInvalid')">作废</a-button>
        </a-button-group>
      </div>

      <!-- 表格 -->
      <div class="tableBody">
        <a-table :row-selection="{
            selectedRowKeys: selectedRowKeys,
            hideDefaultSelections: true,
            onChange: onSelectChange,
          }" :row-key="(record) => `${record.id}`" :columns="columns" :data-source="data"
                 :pagination="false">
          <template slot="mchInfo" slot-scope="text, record">
            <div>{{ record.mchNo }}</div>
            <div style="font-size: 12px; color: #999;">{{ record.mchName || '----' }}</div>
          </template>
          <template slot="consignInfo" slot-scope="text, record">
            <WalletInfo :account-name="record.consignAccountName"
                        :account-no="record.consignAccountNo"
                        :show-account-name="true"
                        :show-account-no="true" />
          </template>
          <template slot="entrustInfo" slot-scope="text, record">
            <WalletInfo :account-name="record.entrustAccountName"
                        :account-no="record.entrustAccountNo"
                        :show-account-name="true"
                        :show-account-no="true" />
          </template>

        </a-table>
      </div>
      <lcfs-pagination :page-no.sync="pagination.pageNo" :page-size.sync="pagination.pageSize"
                       :total="total" :fn="getContracts"></lcfs-pagination>
    </a-card>

    <!-- 审批 模态框 -->
    <a-modal v-model="approveVisible" title="合同审批" @ok="doApprove" :confirm-loading="approveLoading">
      <a-alert :message="`将对合同 ${approveForm.contractNo} 进行审批`" type="info" show-icon />
      <a-form-model :model="approveForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }" style="margin-top: 16px">
        <a-form-model-item label="审批结果" required>
          <a-radio-group v-model="approveForm.approveResult">
            <a-radio value="pass">通过</a-radio>
            <a-radio value="reject">拒绝</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="审批备注">
          <a-textarea v-model="approveForm.approveRemark" :rows="3" placeholder="请输入审批备注" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 作废 模态框 -->
    <a-modal v-model="invalidVisible" title="作废合同" @ok="doInvalid" :confirm-loading="invalidLoading">
      <a-alert message="作废后将同步银行,不可恢复" type="warning" show-icon />
      <p style="margin-top: 16px">确定要作废合同 <b>{{ invalidForm.contractNo }}</b> 吗?</p>
    </a-modal>

    <!-- 保留 Balance 注册(linter 需要看到模板内使用) -->
    <span style="display: none"><Balance :amount="0" dcflag="c" /></span>
  </div>
</template>

<script>
import Balance from '@/view/components/Balance.vue'
import DepartmentChoose from '@/view/components/DepartmentChoose.vue'
import LcfsPagination from '@/view/components/LcfsPagination.vue'
import WalletInfo from '@/view/components/WalletInfo.vue'
import MchChooseDialog from '@/view/components/ChooseDialog/MchChooseDialog.vue'
import { contractStatusConfig, toOptions } from '@/utils/bizDict/consignDict'

export default {
  name: 'ConsignContractList',
  components: { LcfsPagination, DepartmentChoose, Balance, WalletInfo, MchChooseDialog },
  data() {
    return {
      selectedRowKeys: [],
      selectedRows: [],
      total: 0,
      data: [],
      pagination: { pageNo: 1, pageSize: 10 },
      form: {
        contractNo: '',
        mchNo: '',
        mchName: '',
        status: undefined,
        departmentCode: '',
        startTime: '',
        endTime: '',
      },
      dateRange: [],
      contractStatusOptions: toOptions(contractStatusConfig),

      // 模态框
      approveVisible: false,
      approveLoading: false,
      approveForm: { contractNo: '', approveResult: 'pass', approveRemark: '' },
      invalidVisible: false,
      invalidLoading: false,
      invalidForm: { contractNo: '' },
    }
  },
  computed: {
    singleSelected() { return this.selectedRows.length === 1 },
    selected() { return this.singleSelected ? this.selectedRows[0] : null },
    columns() {
      return [
        {
          title: 'No',
          customRender: (text, record, index) =>
            `${Number(this.pagination.pageNo - 1) * Number(this.pagination.pageSize) + Number(index + 1)}`,
          align: "center", width: 30
        },
        { title: '合同号', dataIndex: 'contractNo',   align: "center", width: 120 },
        { title: '商户', key: 'mchInfo',  align: "center", width: 120, scopedSlots: { customRender: 'mchInfo' } },
        { title: '代销方', key: 'consignInfo',   align: "center", width: 120, scopedSlots: { customRender: 'consignInfo' } },
        { title: '委托方', key: 'entrustInfo',  align: "center", width: 120, scopedSlots: { customRender: 'entrustInfo' } },
        { title: '合同起始', dataIndex: 'contractDateStart',  align: "center", width: 80 },
        { title: '合同截止', dataIndex: 'contractDateEnd',  align: "center", width: 80 },
        { title: '年度限额', dataIndex: 'consignYearLimit',  align: "center", width: 60,
          customRender: (t) => <Balance amount={t} dcflag="d" /> },
        { title: '状态', dataIndex: 'status',   align: "center", width: 60,
          customRender: (t) => {
            const c = contractStatusConfig[t] || contractStatusConfig.default
            return <a-tag color={c.color}>{c.label}</a-tag>
          } },
        { title: '创建时间', dataIndex: 'createTime',  align: "center", width: 60 },
        { title: '备注', dataIndex: 'remark'  , align: "center", width: 80},

      ]
    },
  },
  methods: {
    departmentIdchange(v) { this.form.departmentCode = v },
    onDateChange(dates) {
      if (dates && dates.length === 2) {
        this.form.startTime = dates[0]
        this.form.endTime = dates[1]
      } else {
        this.form.startTime = ''
        this.form.endTime = ''
      }
    },
    onSelectChange(keys, rows) {
      this.selectedRowKeys = keys
      this.selectedRows = rows
    },
    async getContracts() {
      const req = { ...this.form, ...this.pagination }
      const res = await this.api.contractPageApi(req)
      if (res.code !== 200) {
        this.$message.error(res.info || '查询失败')
        return
      }
      this.total = res.data.total
      this.data = res.data.records || []
    },
    search() { this.pagination.pageNo = 1; this.getContracts() },
    reset() {
      Object.assign(this.form, {
        contractNo: '', mchNo: '', mchName: '', status: undefined,
        startTime: '', endTime: '',
      })
      this.dateRange = []
      this.search()
    },

    // 搜索表单 — 商户选择
    onMchChosenForQuery(mch) {
      this.form.mchNo = mch.mchNo
      this.form.mchName = mch.mchName
    },

    goAdd() { this.$router.push({ path: '/consign/contract/add' }) },
    goDetail() {
      this.$router.push({
        path: '/consign/contract/detail',
        query: { contractNo: this.selected.contractNo },
      })
    },
    goEdit() {
      // 跳转到 Add.vue,带 contractNo 走编辑模式（不带 type=view 即可编辑）
      this.$router.push({
        path: '/consign/contract/add',
        query: { contractNo: this.selected.contractNo },
      })
    },

    canApprove() { return this.selected && ['0', '1', '3'].includes(this.selected.status) },
    canSync()    { return this.selected && ['2', '3'].includes(this.selected.status) },
    canInvalid() { return this.selected && this.selected.status === '2' },
    // 未审批通过的合同均可编辑:草稿(0)/待审批(1)/已拒绝(3)
    // 编辑保存后状态直接为 PENDING_APPROVAL(无草稿中间态),无需再走"提交审批"
    canEdit()    { return this.selected && ['0', '1', '3'].includes(this.selected.status) },

    openApprove() {
      this.approveForm = {
        contractNo: this.selected.contractNo,
        approveResult: 'pass',
        approveRemark: '',
      }
      this.approveVisible = true
    },

    async doApprove() {
      this.approveLoading = true
      try {
        const res = await this.api.contractApproveApi(this.approveForm)
        if (res.code !== 200) {
          this.$message.error(res.info || '审批失败')
          return
        }
        this.$message.success('审批完成')
        this.approveVisible = false
        this.getContracts()
      } finally {
        this.approveLoading = false
      }
    },

    async doSync() {
      const contractNo = this.selected.contractNo
      const res = await this.api.contractSyncApi(contractNo)
      if (res.code !== 200) {
        this.$message.error(res.info || '同步失败')
        return
      }
      this.$message.success('同步成功')
      this.getContracts()
    },

    openInvalid() {
      this.invalidForm = { contractNo: this.selected.contractNo }
      this.invalidVisible = true
    },

    async doInvalid() {
      this.invalidLoading = true
      try {
        const res = await this.api.contractInvalidApi(this.invalidForm.contractNo)
        if (res.code !== 200) {
          this.$message.error(res.info || '作废失败')
          return
        }
        this.$message.success('已作废')
        this.invalidVisible = false
        this.getContracts()
      } finally {
        this.invalidLoading = false
      }
    },

  },
  mounted() {
    Object.assign(this.form, this.$route.query)
    this.getContracts()
  },
  // keep-alive 缓存下,从 Add.vue/Detail.vue 返回时不会重新 mounted
  // 用 activated 识别 Add.vue 提交的 fromAddPage / fromEditPage 来强制刷新列表
  activated() {
    if (this.$route.query.fromAddPage) {
      // 新增返回:重置分页到第 1 页,清空筛选(用户期望看到新合同)
      this.pagination.pageNo = 1
      this.selectedRowKeys = []
      this.selectedRows = []
      this.getContracts()
    } else if (this.$route.query.fromEditPage) {
      // 编辑返回:保留筛选条件,仅刷新当前页
      this.getContracts()
    }
  },
}
</script>

<style scoped>
.top-title { display: flex; justify-content: space-between; align-items: center; }
.top-title .left span { font-weight: 600; }
.formbox { display: flex; flex-wrap: wrap; align-items: center; gap: 12px; padding: 12px 0; }
.inputbox { display: flex; align-items: center; gap: 8px; }
.lefttitle { width: 80px; color: #666; }
.Toleadinto { margin: 12px 0; }
.tablebox { margin-top: 8px; }
.reset { margin-left: 8px; }
</style>
